import { config } from '@endaoment-frontend/config';

import { AdvisorsHeader, FeeComparison } from '../content/advisors';
import { DoubleFeature } from '../content/doubleFeature';
import { MediaCarousel } from '../content/mediaCarousel';
import { MetaTags } from '../content/metaTags';
import { NDAOTokenCallout } from '../content/ndaoTokenCallout';
// import { NDAOTokenCallout } from '../content/ndaoTokenCallout';
import { SocialLinks } from '../content/socialLinks';
import { TextGridWithLogo } from '../content/textGridWithLogo';
import { TwoScreensSection } from '../content/twoScreensSection';
import myFundsDT from '../images/screenshots/myFundsDT.png';
import reproRightsDT from '../images/screenshots/reproRightsDT.png';

const AdvisorsPage = () => {
  return (
    <>
      <MetaTags url="/advisors" title="Endaoment | Advisors" />

      <AdvisorsHeader />
      <DoubleFeature
        pillLeft="In-App Donations"
        pillRight="OTC Donations"
        headerLeft="Donate over 1,000+ different kinds of digital assets"
        headerRight="Donate from other blockchains over-the-counter"
        extraLeft="Industry-low 1.5% fee"
        extraRight="Yes, even NFTs"
      />

      <TextGridWithLogo
        headerText="Self-directed, crypto-native, flexible giving without compromising on compliance."
        pillText="Built for Crypto Investors"
      >
        <TextGridWithLogo.Item
          header="Donor-Advised Funds"
          text="Donate any asset at any time and get a tax receipt immediately. Come back later and make grant recommendations to more than 1.5 million nonprofits whenever inspiration strikes."
          buttonText="Open a Fund"
          href={`${config.clientBaseUrl}/funds/create`}
        />
        <TextGridWithLogo.Item
          header="Direct Donations"
          text="Know where you want to give? Head straight to the profile of your favorite nonprofit and easily donate any crypto asset directly to the organization."
          buttonText="Find an Org"
          href={`${config.clientBaseUrl}/orgs`}
        />
        <TextGridWithLogo.Item
          header="Community Funds"
          text="Not sure where to give? Community Funds leverage our incredible community's knowledge base to direct donations around specific issue areas and causes."
          buttonText="Browse Community Funds"
          href={`${config.clientBaseUrl}/funds/community`}
        />
        <TextGridWithLogo.Item
          header="Endorsements"
          text="Soon you can help us curate the best and most effective nonprofits by endorsing them. Earn rewards for contributing your perspective while driving excess fee revenue to organizations you endorse."
          comingSoon
          // TODO: Figure out where this goes
          href={'#'}
        />
        <TextGridWithLogo.Item
          header="Portfolio Allocations"
          text="Don't let your philanthropic capital sit idly by while you find the perfect organization to support. Easily deploy dollars in your Endaoment Fund into DeFi yield bearing and crypto investment options."
          comingSoon
          // TODO: Figure out where this goes
          href={'#'}
        />
      </TextGridWithLogo>

      <FeeComparison />
      <TwoScreensSection
        title="Comprehensive On-Chain Donation Interface"
        image1Src={myFundsDT}
        image2Src={reproRightsDT}
        subtext=""
      >
        <TwoScreensSection.Button text="Launch App" href={config.clientBaseUrl} />
      </TwoScreensSection>
      <NDAOTokenCallout />
      <MediaCarousel />
      <SocialLinks />
    </>
  );
};

export default AdvisorsPage;
